import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PAYMENT_PRICING } from './planCatalog';

const PaymentSystemPanel = ({ onDemandPrId }) => {
  const navigate = useNavigate();
  const { dcdialProcessor, ownProcessor } = PAYMENT_PRICING;

  const handleStartPayments = () => {
    navigate('/signup', { state: { pr_id: onDemandPrId } });
  };

  return (
    <div className="relative mt-7">
      <div className="grid grid-cols-3 gap-5 max_md:grid-cols-1">
        <div className="flex h-full flex-col justify-between rounded-[22px] bg-white/[0.04] p-6 ring-1 ring-inset ring-white/10">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#75C9FF]">
              Your payments-only setup
            </p>
            <div className="mt-4 flex items-center justify-between gap-4 border-t border-white/10 pt-3">
              <span className="text-[13px] text-white/80">
                On Demand software plan{' '}
                <span className="text-white/45">— this is your account</span>
              </span>
              <span className="shrink-0 text-[16px] font-DMSansFont font-bold text-white">
                $0<span className="text-[11px] font-semibold text-white/45">/mo</span>
              </span>
            </div>
            <div className="mt-3 flex items-center justify-between gap-4 border-t border-white/10 pt-3">
              <span className="text-[13px] text-white/80">Payment processing</span>
              <span className="shrink-0 text-[13px] font-bold text-[#75C9FF]">
                choose a processor
              </span>
            </div>
          </div>
          <p className="mt-5 text-[12px] leading-5 text-white/55">
            No paid software subscription required. Upgrade your plan only if you need
            engagement capacity later.
          </p>
        </div>
        <article className="flex h-full flex-col rounded-[22px] bg-ButtonPrimary p-7 shadow-[0_22px_60px_rgba(0,160,252,0.3)] max_600:p-6">
          <div className="mb-5 flex h-[26px] items-center">
            <span className="rounded-full bg-white px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-ButtonPrimary">
              No monthly fee
            </span>
          </div>
          <h3 className="text-[26px] font-DMSansFont font-bold tracking-[-0.5px] text-white">
            {dcdialProcessor.name}
          </h3>
          <div className="mt-5 flex items-end gap-2">
            <span className="text-[42px] font-DMSansFont font-bold leading-none tracking-[-1.5px] text-white">
              $0
            </span>
            <span className="pb-1 text-[13px] font-semibold text-white/70">/month</span>
          </div>
          <div className="mt-6 space-y-3">
            {dcdialProcessor.rates.map((item) => (
              <div
                key={item.method}
                className="flex items-center justify-between border-t border-white/25 pt-3"
              >
                <span className="text-[13px] font-semibold text-white/80">{item.method}</span>
                <span className="text-[15px] font-DMSansFont font-bold text-white">
                  {item.rate}
                </span>
              </div>
            ))}
          </div>
          <p className="mt-4 text-[12px] leading-5 text-white/75">{dcdialProcessor.qualifier}</p>
          <div className="mt-auto pt-6">
            <button
              type="button"
              onClick={handleStartPayments}
              className="w-full rounded-[10px] bg-white px-4 py-3 text-[14px] font-bold text-LightPrimary transition-colors hover:bg-white/90"
            >
              Start Collecting Payments
            </button>
          </div>
        </article>

        <article className="flex h-full flex-col rounded-[22px] bg-white/[0.07] p-7 ring-1 ring-inset ring-white/10 max_600:p-6">
          <div className="mb-5 flex h-[26px] items-center">
            <span className="rounded-full bg-white/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-white/80">
              Bring your own
            </span>
          </div>
          <h3 className="text-[26px] font-DMSansFont font-bold tracking-[-0.5px] text-white">
            {ownProcessor.name}
          </h3>
          <p className="mt-2 text-[13px] leading-5 text-white/65">
            Keep your existing processor and run it through DCDial. Pricing scales with your
            annual payment volume.
          </p>
          <div className="mt-5 space-y-3">
            {ownProcessor.tiers.map((tier) => (
              <div key={tier.revenue} className="border-t border-white/15 pt-3">
                <span className="block text-[11px] font-bold uppercase tracking-[0.08em] text-white/45">
                  {tier.revenue}
                </span>
                <div className="mt-1 flex items-baseline justify-between">
                  <span className="text-[19px] font-DMSansFont font-bold text-white">
                    ${tier.monthlyFee.toLocaleString()}
                    <span className="ml-1 text-[12px] font-semibold text-white/55">/month</span>
                  </span>
                  <span className="text-[13px] font-semibold text-[#75C9FF]">
                    + {tier.revenueShare}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-auto pt-6">
            <button
              type="button"
              onClick={() => navigate('/contact/get-in-touch')}
              className="w-full rounded-[10px] bg-white px-4 py-3 text-[14px] font-bold text-LightPrimary transition-colors hover:bg-[#EAF7FF]"
            >
              Talk to Sales
            </button>
          </div>
        </article>
      </div>

      <p className="mt-5 rounded-[14px] bg-white/[0.055] px-5 py-4 text-center text-[13px] leading-6 text-white/70 ring-1 ring-inset ring-white/10">
        <strong className="text-white">Using software plans too?</strong> Processing rates are
        identical on every plan — your plan sets engagement capacity, your processor choice
        sets your rates.
      </p>
    </div>
  );
};

export default PaymentSystemPanel;
